import { FC } from 'react';

// ========================= 组件 =========================
import NextImage from '@/components/image';
import IconFont from '@/components/iconfont';

// ========================= 数据交互 =========================

// ========================= 全局数据 =========================

// ========================= 常量 =========================

// ========================= 工具 =========================

// ========================= 样式 =========================
import styles from './index.module.css';

// ========================= 变量 =========================

// ========================= 类型 =========================

interface Item {
    id: number;
    [key: string]: any;
}

interface ImagePreviewProps {
    items: Item[];
    visible?: boolean;
    imageIndex?: number;
    imagePropsName?: string;
    titlePropsName?: string;
    onClose?: () => void;
    onChange?: (index: number, action: 'pre' | 'next') => void;
}

const ImagePreview: FC<ImagePreviewProps> = ({
    items,
    visible,
    imageIndex = 0,
    imagePropsName = 'url',
    titlePropsName = 'title',
    onClose,
    onChange
}) => {
    if (!visible) {
        return null; // 如果不可见，直接返回null
    }
    return (
        <section
            className={styles.images_popups}
            id="images_popups"
            onClick={(e: React.MouseEvent<HTMLElement, MouseEvent>) => {
                const id = (e.target as HTMLElement).id as string;
                if (id === "images_popups") {
                    onClose && onClose();
                }
            }}
        >
            <div className={styles.images_popups_wrapper}>
                <h3 className={styles.images_popups_title}>
                    {items[imageIndex]?.[titlePropsName]}
                </h3>
                <section className={styles.images_content}>
                    <IconFont
                        type="icon-houtui"
                        role="button"
                        className={styles.images_popups_Prev}
                        onClick={() => onChange && onChange(imageIndex, 'pre')}
                    />
                    <NextImage
                        className={styles.image}
                        src={items[imageIndex]?.[imagePropsName] || ''}
                        alt={items[imageIndex]?.['titlePropsName'] || ''}
                        width={1280}
                        height={450}
                        blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP89/dfPQAJdAN6CIDaegAAAABJRU5ErkJggg=="
                    />

                    <IconFont
                        type="icon-qianjin"
                        role="button"
                        className={styles.images_popups_Next}
                        onClick={() => onChange && onChange(imageIndex, 'next')}
                    />
                </section>
            </div>
        </section>
    );
}
export default ImagePreview;